import { createContext, useContext } from "react";

export type ToolbarState = {
  isBold: boolean;
  isItalic: boolean;
  isUnderline: boolean;
  isStrikethrough: boolean;
  isCode: boolean;
  isSubscript: boolean;
  isSuperscript: boolean;
  isLink: boolean;
  blockType: string;
  canUndo: boolean;
  canRedo: boolean;
};

export const defaultToolbarState: ToolbarState = {
  isBold: false,
  isItalic: false,
  isUnderline: false,
  isStrikethrough: false,
  isCode: false,
  isSubscript: false,
  isSuperscript: false,
  isLink: false,
  blockType: "paragraph",
  canUndo: false,
  canRedo: false,
};

export const ToolbarContext = createContext<ToolbarState>(defaultToolbarState);

export const useToolbarState = () => useContext(ToolbarContext);
